module.exports = __webpack_public_path__ + "img/btn-faq@2x.eabc76b3.jpg";